import Ticket from './Ticket';
import Order from './Order';

export const createOrder = (json) => {
    if (json.ticketSet?.[0]?.id !== undefined) {
        return new Ticket(json);
    }
    return new Order(json);
}
